export const APPROVAL_LIST = "APPROVAL_LIST";
export const ACCEPT = "ACCEPT";
export const REJECT = "REJECT";
export const INS_APPROVAL_LIST = "INS_APPROVAL_LIST";
export const INS_DETAILS_LIST = "INS_DETAILS_LIST";
export const LEAD_APPROVAL_LIST= "LEAD_APPROVAL_LIST";
export const EXISTING_PROJECT_LIST="EXISTING_PROJECT_LIST";
export const TAG_APPROVAL_LIST = "TAG_APPROVAL_LIST";
export const TAG_DETAILS_LIST = "TAG_DETAILS_LIST";
export const SAVE_LOGS_FOR_CONTRACT = "SAVE_LOGS_FOR_CONTRACT";
